import { Box, Grid } from "@mui/material";
import SimpleTable, { SimpleTableHeader } from "../../components/SimpleTable";
import { Ability } from "../../model/character";
import HeadingBar from "../../components/HeadingBar";

interface AbilityDisplayProps {
    abilities: Ability[];
    isStrongHit?: boolean;
}

const AbilityDisplay = (props: AbilityDisplayProps) => {
    const { abilities, isStrongHit } = props;

    return <Box marginLeft={1}>
        {/* <HeadingBar extendBunts>
            <Grid container  paddingX={1}>
                <Grid item xs={3}><SimpleTableHeader>Name</SimpleTableHeader></Grid>
                <Grid item xs={2}><SimpleTableHeader tooltip="Requirements">Rq</SimpleTableHeader></Grid>
                <Grid item xs={2}><SimpleTableHeader tooltip="Results">Re</SimpleTableHeader></Grid>
                <Grid item xs={2}><SimpleTableHeader tooltip="Limits">Li</SimpleTableHeader></Grid>
                <Grid item xs={3}><SimpleTableHeader tooltip="Uses of the strong hit">Uses</SimpleTableHeader></Grid>
            </Grid>
        </HeadingBar>
        <SimpleTable entries={strongHits.map((sh) => {
            return <Grid container paddingX={1}>
                <Grid item xs={3}>{sh.name}</Grid>
                <Grid item xs={2}>{sh.requirements}</Grid>
                <Grid item xs={2}>{sh.results}</Grid>
                <Grid item xs={2}>{sh.limits}</Grid>
                <Grid item xs={3}>{sh.limitedUseMax}</Grid>
            </Grid>
        })} /> */}
        {abilities.map((sh) => {
            return <div>
                <div style={{fontWeight: "700"}}>{sh.name}</div>
                {isStrongHit && <>
                    <div>Requirements: {sh.requirements}</div>
                    <div>Effect: {sh.results}</div>
                </>}

                {isStrongHit !== true && <>
                    <div>{sh.requirements}, {sh.limits}, {sh.type}</div>
                    <div>{sh.results}</div>
                </>}
            </div>
        })}
    </Box>
}

export default AbilityDisplay;